import { ComponentType } from 'react';

export const enum OptionComponentEnum {
  link = 'link',
  button = 'button',
}

export type MenuOptionType = {
  id: 'view_details' | 'follow' | 'remove_account';
  label: string;
  type: OptionComponentEnum;
  Icon: ComponentType;
};
